module.exports = "bundles/509c03bbb2f3ff5d1d5d4f8daefbeda5.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/plus2.png
// module id = 140
// module chunks = 0